<template>

	<div class="help-panels">

		<v-expansion-panels tile>

			<v-expansion-panel>
				<v-expansion-panel-header>
					{{ $t('helpContents.myTokens.whatAreWETHWrapUnwrap.title') }}
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<div v-html="$t('helpContents.myTokens.whatAreWETHWrapUnwrap.contents')"></div>
				</v-expansion-panel-content>
			</v-expansion-panel>

			<v-expansion-panel>
				<v-expansion-panel-header>
					{{ $t('helpContents.myTokens.whatIsAllowance.title') }}
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<div v-html="$t('helpContents.myTokens.whatIsAllowance.contents')"></div>
				</v-expansion-panel-content>
			</v-expansion-panel>

			<v-expansion-panel>
				<v-expansion-panel-header>
					{{ $t('helpContents.myTokens.howToRemoveToken.title') }}
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<div v-html="$t('helpContents.myTokens.howToRemoveToken.contents')"></div>
				</v-expansion-panel-content>
			</v-expansion-panel>

		</v-expansion-panels>


	</div>


</template>

<script>

export default {
	name: 'TokensHelp',
	props: {
	},
	data () {
		return {
		}
	},
}
</script>


<style scoped>

</style>
